// RS 2022-06-01 ADO ADO 6565 - Add Date picker content
import React, { Component, Suspense } from 'react';
import DatePicker, { getDefaultLocale } from "react-datepicker";
import moment from 'moment';
import 'moment/locale/fr';
import CustomDateInput from './CustomDateInput';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
//RS: 2022-05-30 - ADO 6865 - Use the translation
i18n.on('initialized', function (options) {
	const { t, i18n } = useTranslation();
})

export default class QuoteFlowFormStep extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showcollapsibleinput: {}
		};
	}

	render() {
		if (this.props.getStepVisibleFieldCount(this.props.step) === 0) {
			return null;
		} else {
			let stepTitle = this.props.step.Title;
			return (
				<div className={`quoteFlowStep quoteFlowStep${this.props.stepIndex} ${this.props.activeStep}  ${this.props.step.completed ? 'completed' : ''}`}>
					<div className="quote-flow__step__title-holder d-flex align-items-center">
						<h5>{stepTitle}</h5>
						{this.props.step.Icon ? <div className="quote-flow__step__img-holder d-flex align-items-center"><img className="img-fluid" src={this.props.step.Icon} /></div> : ''}
					</div>
					<div className={`quoteFlowStep__options ${this.needsRadioOptionsClassName(this.props.step.Input[0])}`}>
						{this.renderStepOptions()}
					</div>
				</div>
			)
		}
	}

	renderStepOptions = () => {
		const options = this.props.step.Input;

		if (!options) {
			return null;
		}
		return options.map((option, index) => {
			if (option.HideWhen == this.props.quoteFlowPath || !option.Name) {
				return null;
			} else {
				switch (option.InputType.toLowerCase()) {
					case 'radio':
					case 'radiolink':
					//rs 11-29-22 - add new input type
					case 'radiopaved':
						return this.renderRadioOption(option, index);
					case 'text':
					case 'collapsible':
						return this.renderTextOption(option, index);
					case 'email':
						return this.renderEmailOption(option, index);
					case 'select':
						return this.renderSelectOption(option, index);
					case 'calendar':
						return this.renderCalendarOption(option, index);
					case 'hidden':
						return this.renderHiddenOption(option, index);
					default:
						return null;
				}
			}
		});
	}

	renderRadioOption = (option, index) => {
		let FField = this.props.Field;
		return (
			<FField
				component={this.renderRadioField}
				name={option.Name}
				items={option.Value}
				//rs 11-29-22 - pass legend prop
				legend={option.Legend}
				validate={this.requiredValidator}
				key={index}
				onChange={(e, newValue, previousValue) => {
					this.props.handleFieldChange(e.target, this.props.step, option, this.props.stepIndex)
				}
				}
			/>
		);
	}

	//rs 11-29-22 - pass legend
	renderRadioField = ({ input, legend, meta: props, items }) => {
		if (!this.props.activeStep) {
			input.tabIndex = '-1';
		}
		let requiredMessage = this.getRadioRequiredMessage(input);
		//rs 11-29-22 - test for pavedDriveway & legend prop
		var classType = (input.name == "pavedDriveway") ?  input.name + " d-none" : input.name;
		var legendItem = (legend != null) ? <legend>{legend}</legend> : "";
		return (
			<div className={this.props.manualErrors[input.name] && !input.value ? 'quoteFlowForm__error ' : ""}>
				<ul className={`quoteFlowRadios ` + classType}>
					{legendItem}
					{items.map((item, index) => {
						let itemValue = item.Value || item.Label.replace(/[^a-z0-9+]+/gi, '').toLowerCase();
						sessionStorage.setItem('NoStorageAvailableLabel', item.NoStorageAvailableLabel);

						return (
							<li key={index}>
								<label className="radio-input-container">
									<input
										name={input.name}
										id={itemValue}
										type="radio"
										onChange={input.onChange}
										value={itemValue}
										checked={item.Value === this.props.formValues[input.name]}
									/>
									<span className="radio-input-inner" id={itemValue.toUpperCase()}>
										<span className="radio-checkmark"><img src="/Assets/images/icon-radio-check.svg" alt="checkmark" /></span>
										{item.Label}
									</span>
								</label>
							</li>
						)
					})}
				</ul>
				{requiredMessage}
			</div>
		);
	}

	getRadioRequiredMessage = (input) => {
		if (this.props.manualErrors[input.name] && !input.value) {
			//RS: 2022-05-30 - ADO 6865 - Translate Error
			return <div className="quoteFlowForm__error-message form-error-message quoteFlowForm__error-message-radio"><span>{i18n.t('RequiredField')}</span></div>;
		}
		return null;
	}

	renderTextOption = (option, index) => {
		let inValidator = () => { return undefined };
		let onChange = () => { };
		if (option.Name.toLowerCase().indexOf('zipcode') > -1) {
			inValidator = this.zipValidator;
		} else if (option.Name.toLowerCase().indexOf('email') > -1) {
			inValidator = this.emailValidator;
		} else if (option.Name.toLowerCase() === "phone") {
			inValidator = this.telephoneValidator;
		} else if (option.Required) {
			inValidator = this.requiredValidator;
		}
		let FField = this.props.Field;
		return (
			<div key={option.Name} className={`quoteFlowText quote-flow__text-field-${option.Name}`}>
				<FField
					component={this.renderTextField}
					placeholder={option.PlaceholderText}
					name={option.Name}
					type={option.InputType}
					value={option.Value}
					label={option.Label}
					validate={inValidator}
					classType={option.Class}
					onChange={(e, newValue, previousValue) => {
						this.props.handleFieldChange(e.target, this.props.step, option, this.props.stepIndex)
					}					
					}
					key={index}
				/>
			</div>
		)
	}

	renderEmailOption = (option, index) => {
		let inValidator = () => { return undefined };
		let onChange = () => { };
		if (option.Name.toLowerCase().indexOf('zipcode') > -1) {
			inValidator = this.zipValidator;
		} else if (option.Name.toLowerCase().indexOf('email') > -1) {
			inValidator = this.emailValidator;
		} else if (option.Name.toLowerCase() === "phone") {
			inValidator = this.telephoneValidator;
		} else if (option.Required) {
			inValidator = this.requiredValidator;
		}
		let FField = this.props.Field;
		return (
			<div key={option.Name} className={`quoteFlowText quote-flow__text-field-${option.Name}`}>
				<FField
					component={this.renderTextField}
					placeholder={option.PlaceholderText}
					name={option.Name}
					type={option.InputType}
					value={option.Value}
					label={option.Label}
					validate={inValidator}
					classType={option.Class}
					onBlur={(e, newValue, previousValue) => {
						this.props.handleFieldChange(e.target, this.props.step, option, this.props.stepIndex)
					}					
					}
					key={index}
				/>
			</div>
		)
	}

	renderTextField = ({ input, label, placeholder, type, classType, meta: props }) => {
		if (!this.props.activeStep) {
			input.tabIndex = '-1';
		}
		var maxLength = '';
		if (input.name === 'promotionCode') {
			type = 'collapsible';
			maxLength = "25";
		}
		return (
			<div className={`${this.getCollapseFieldClass(input)} ${type}-field-holder`}>
				<label {...this.getTextLabelProps(input, type, label)}><span className="quoteflow__collapsible-showMe quoteflow__collapsible-collapseSymbol">+ </span><span className="quoteflow__collapsible-hideMe quoteflow__collapsible-collapseSymbol">- </span>{label}</label>
				<div className={`${(this.props.manualErrors[input.name] && !input.value) || ((props.touched || props.submitting) && props.error) ? 'quoteFlowForm__error' : ''} ${type}-field`}>
					<input
						autoComplete="new-password"
						{...input} id={input.name} placeholder={placeholder} className={classType} type={type} maxlength={maxLength}
					/>

					{(this.props.manualErrors[input.name] && !input.value) || ((props.touched || props.submitting) && props.error) ? <div className="quoteFlowForm__error-message form-error-message"><span>{props.error}</span> &nbsp;</div> : ''}
				</div>
			</div>
		)
	}

	getCollapseFieldClass = (input) => {
		return this.state.showcollapsibleinput[input.name] || (input.name == "promotionCode" && input.value != "") ? 'uncollapse' : ''
	}

	getTextLabelProps = (input, type, label) => {
		let labelProps = {};
		if ((type && type.toLowerCase() === 'collapsible' && !input.value || input.value && input.value.length === 0) || input.name === 'promotionCode') {
			labelProps = {
				onClick: () => {
					let showCollapseItem = { ...this.state.showcollapsibleinput };
					if (showCollapseItem[input.name]) {
						showCollapseItem[input.name] = false;
					} else {
						showCollapseItem[input.name] = true;
					}
					this.setState({ showcollapsibleinput: showCollapseItem });
				}
			}
		}
		return labelProps;
	}

	renderHiddenOption = (option, index) => {
		let FField = this.props.Field;
		return (
			<FField
				component={this.renderTextField}
				name={option.Name}
				type={option.InputType}
				value={option.Value}
				key={index}
			/>
		)
	}

	renderSelectOption = (option, index) => {
		let FField = this.props.Field;

		let onChange = (e) => { this.props.handleFieldChange(e.target, this.props.step, option, this.props.stepIndex) };
		let selectDisabled = false;
		if (option.Value.length < 2) {
			selectDisabled = true;
		}
		let validator = this.requiredValidator;
		if (option.Name.toLowerCase() === 'duration') {
			validator = this.durationValidator;
		}
		return (
			<div key={index} className={`quoteFlowSelect`}>
				<FField
					loadingText={option.PlaceholderText}
					disabled={selectDisabled}
					onChange={onChange}
					label={option.Label}
					name={option.Name}
					component={this.renderSelectField}
					validate={validator}>
					{this.renderSelectOptions(option.Value)}
				</FField>
			</div>
		)
	}

	renderSelectOptions = (options) => {
		if (options.length === 0 || options.length === 1 && options[0].Value === null) {
			return null;
		}
		return options.map((option, index) => {
			return <option key={`${option.Value}${index}`} value={option.Value}>{option.Label}</option>
		})
	}

	renderSelectField = ({ input, meta: props, children, label, disabled, loadingText }) => {
		if (!this.props.activeStep) {
			input.tabIndex = '-1';
		}
		return (
			<div className={` ${(this.props.manualErrors[input.name] && !input.value) || ((props.touched || props.submitting) && props.error) ? 'quoteFlowForm__error' : ''} ${disabled ? 'quoteFlowForm__select-disabled' : ''} `}>

				<div className={`quoteFlowForm__select-wrapper-${input.name}`}>
					<div className={`quoteFlowForm__select-holder ${!children || (children && children.length === 1) ? 'hideMe' : ''}`}>
						<select {...input}>
							{children}
						</select>
					</div>
					{(this.props.manualErrors[input.name] && (!input.value || input.value === 0)) || ((props.touched || props.submitting) && props.error) ?
						<div className="quoteFlowForm__error-message form-error-message"><span>{props.error}</span> &nbsp;</div> : ''}
				</div>
			</div>
		)
	}

	changeDate = (date) => {
		let utcDate = moment(date).startOf('day').utc(); // convert the selected date to UTC, which is sometimes the day before or after the date chosen because of timezone differences
		const timeZoneOffset = moment(date).utcOffset(); // how many minutes difference between local time and utcDate
		let localDate = timeZoneOffset > 0 ? moment(utcDate).add(timeZoneOffset, 'minutes') : moment(utcDate).subtract(timeZoneOffset + 1, 'minutes');
		this.props.setQuoteFlowFormFieldValue('selectedDate', localDate.valueOf());
	}

	renderCalendarOption = (option, index) => {
		let FField = this.props.Field;
		return (
			<div key={index} className={`quoteFlowCalendar`}>
				<FField
					hiddenFieldName={option.Name}
					name={`${option.Name}_display`}
					component={this.renderCalendarField}
					type={option.InputType}
					value={option.Value}
					label={option.Label}
					excludeDates={this.props.availabilityDates}
					validate={this.requiredValidator}
					onChange={(date) => { this.changeDate(date); this.props.handleFieldChange(null, this.props.step, option, this.props.stepIndex); }}
				/>
				<FField
					component={this.renderTextField}
					name={option.Name}
					type="hidden"
					value={option.Value ? moment(option.Value) : null}
				/>
			</div>
		);
	}

	renderCalendarField = ({ input, meta: props, excludeDates, label, hiddenFieldName }) => {
		//RS: 2022-05-30 - ADO 6865 - Update Language & Time Format
		if (window.location.href.indexOf("/fr/") > -1) {
			var lang = 'fr'
			var localeDate = 'dddd DD MMMM, YYYY'
		}
		else {
			var lang = 'en'
			var localeDate = 'dddd MMMM DD, YYYY'
		};
		return (
			<div className={props.touched && props.error ? 'quoteFlowForm__error' : ''}>
				<label>{label}</label>
				<div className="quote-flow__calendar-holder">
					<DatePicker {...input}
						locale={moment.locale(lang)}
						openToDate={this.props.startOfMonth}
						customInput={<CustomDateInput />}
						dateForm="MM/DD/YYYY"
						value={input.value ? moment(input.value).format(localeDate) : null}
						minDate={moment().add(1, 'day')}
						maxDate={moment().add(1, 'year')}
						excludeDates={this.props.availabilityDates}
						onMonthChange={(val) => { this.props.handleMonthChange(val, this.props.step) }}
					/>
				</div>
				{props.touched && props.error ? <div className="quoteFlowForm__error-message form-error-message"><span>{props.error}</span>&nbsp;</div> : ''}
			</div>
		);
	}

	zipValidator = (value) => {
		if (!this.props.zipCodeValidator(value)) {
			//RS: 2022-05-30 - ADO 6865 - Translate Error
			return i18n.t('InvalidZip');
		} else {
			return undefined;
		}
	}

	emailValidator = (value) => {
		if (!value || value.length === 0 || !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value)) {
			//RS: 2022-05-30 - ADO 6865 - Translate Error
			return i18n.t('InvalidEmail');
		} else {
			return undefined;
		}
	}

	telephoneValidator = (value) => {
		if (!value || value.length === 0 || !/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/g.test(value)) {
			//RS: 2022-05-30 - ADO 6865 - Translate Error
			return i18n.t('InvalidPhone')
		} else {
			return undefined;
		}
	}

	requiredValidator = (value) => {
		value=$.trim(value);
		if (!value || value.length === 0) {
			//RS: 2022-05-30 - ADO 6865 - Translate Error
			return i18n.t('RequiredField');
		}
	}

	durationValidator = (value) => {
		if (!value || value == 0) {
			//RS: 2022-05-30 - ADO 6865 - Translate Error
			return i18n.t('RequiredField');
		}
	}

	needsRadioOptionsClassName = (option) => {
		//rs 11-29-22 - if this is used, pass the same info
		if (option && option.InputType && (option.InputType === "radio" || option.InputType === "radioLink" || option.InputType === "radioPaved")) {
			return " quoteFlowStep__radio-button-holder";
		}
		return '';
	}


}
